import _ from 'lodash'

/**
 * Converts an array to a hash to allow O(1) lookups of whether a value is
 * contained in the array
 * @deprecated Use a Set instead
 */
function arrayToHash(array, val = _.stubTrue) {
	return _.transform(array, function(result, value, key) {
		result[value] = val(value, key)
	}, {})
}

export default arrayToHash

arrayToHash.__filename__ = 'components/array-to-hash.js'
